<template>
    <div class="mx-auto w-full max-w-sm">
      <div>
        <img class="h-12 w-auto" src="@/assets/af_logo_dark.svg" alt="Artifex" />
        <h2 class="mt-6 text-3xl leading-9 font-extrabold text-gray-900">
          Sign in to your account
        </h2>
        <p class="mt-2 text-sm leading-5 text-gray-600 max-w">
          Or
          <a href="#" class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150">
            apply to join our team.
          </a>
        </p>
      </div>

      <div class="mt-8">
        <div>
          <div>
            <p class="text-sm leading-5 font-medium text-gray-700">
              Sign in with
            </p>

            <div class="mt-1 grid grid-cols-3 gap-3">
              <div>
                <span class="w-full inline-flex rounded-md shadow-sm">
                  <a type="button" href="#" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" aria-label="Sign in with Discord">
                    <img src="@/assets/Discord-Wordmark-Black.svg" alt="Discord" height="30px" width="auto" />
                  </a>
                </span>
              </div>
              <div>
                <span class="w-full inline-flex rounded-md shadow-sm">
                  <a type="button" @click.prevent="fireAndCatchToken();" class="w-full inline-flex justify-center py-1 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" aria-label="Sign in with Battle.net">
                    Click me
                  </a>
                </span>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
</template>


<script>
  import store from '@/store/index'

  export default {
    name: 'discordLoginSSO',
    data() {
      return {
        code: '',
        tokenReturn: {},
        userReturn: {},
      }
    },
    methods: {
      fireAndCatchToken() {

        const discordData = new FormData()
        discordData.append('code', this.code)
        discordData.append('client_id', '704359475368165557')
        discordData.append('client_secret', 'BQhJcyT5N1ZeI-a8DDUNiiOPoW7PG4wR')
        discordData.append('redirect_uri', 'https://ara.gg/login/discord')
        discordData.append('grant_type', 'authorization_code')
        discordData.append('scope', 'Identify')

        const that = this
        this.$http.frExternal.post('https://discordapp.com/api/oauth2/token', discordData).then((response) => {
          if (response.data.error == true) {
            throw Error(response.data.error_text)
          } else {
            that.tokenReturn = response.data
            that.$http.external({
              url: 'https://discordapp.com/api/users/@me',
              headers: {
                'Authorization': 'Bearer ' + that.tokenReturn.access_token
              }
            }).then((response) => {
              if (response.data.error == true) {
                throw Error(response.data.error_text)
              } else {
                store.commit('updateUserResponse', response.data)
                store.commit('signIn')
                that.$router.push('/')
              }
            }).catch(err => {
              console.log('caught it!', err);
            })
          }
        }).catch(err => {
          console.log('caught it!', err);
        })
      }
    },
    mounted () {
      this.code = this.$route.query.code
      this.fireAndCatchToken();
    },
  }
</script>
